import { render, staticRenderFns } from "./IconOnly.vue?vue&type=template&id=67c22da2"
import script from "./IconOnly.vue?vue&type=script&lang=js"
export * from "./IconOnly.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports